import { deserialize, fetchWrapper } from '../fetch';
import type { Artifact, ArtifactTemplate, SchemaBundle } from './interface';

export const fetchArtifact = async (
  dossierId: string,
  artifactId: string
): Promise<Artifact> => {
  const url = new URL(
    `/app/v1/dossiers/${dossierId}/artifacts/${artifactId}`,
    API_BASE_URL
  );
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const fetchDossierArtifacts = async (
  dossierId: string
): Promise<Artifact[]> => {
  const url = new URL(`/app/v1/dossiers/${dossierId}/artifacts`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const fetchArtifactTemplates = async (
  dossierId: string
): Promise<ArtifactTemplate[]> => {
  const url = new URL(`/app/v1/dossiers/${dossierId}/templates`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const generateArtifact = async ({
  dossierId,
  schemaName,
  taskId,
}: {
  dossierId: string;
  schemaName: string;
  taskId?: string;
}): Promise<Artifact> => {
  const url = new URL(`/app/v1/dossiers/${dossierId}/artifacts`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ schema_name: schemaName, task_id: taskId }),
    })
  );
};

export const fetchSchema = async (
  schemaName: string
): Promise<SchemaBundle> => {
  const url = new URL(`/app/v1/schemas/${schemaName}`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
